import { useState } from "react";
import { toast } from "sonner";
import { Sparkles, Loader2 } from "lucide-react";
import { api, formatErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { confetti } from "@/lib/celebrate";

const QUICK = [50, 100, 250, 500];

export function SkyDonate({ onDone }) {
  const { user, refreshUser } = useAuth();
  const [amount, setAmount] = useState("100");
  const [busy, setBusy] = useState(false);
  const give = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/sky/donate", { amount: Number(amount) });
      toast.success(`${data.used} Sternenstaub verschenkt – danke! ✨`);
      confetti({ y: innerHeight / 3, count: 50, colors: ["#fde68a", "#f9a8d4", "#ffffff"] });
      onDone(data);
      refreshUser?.();
    } catch (e) { toast.error(formatErr(e)); } finally { setBusy(false); }
  };
  return (
    <div className="rounded-3xl bg-white border border-pink-100 p-5 space-y-3" data-testid="sky-donate">
      <p className="font-bold flex items-center gap-2"><Sparkles className="w-4 h-4 text-amber-500" /> Punkte in Sternenstaub verwandeln</p>
      <p className="text-xs text-slate-500">1 Punkt = 1 Sternenstaub. Du hast <b data-testid="sky-my-points">{user?.points ?? 0}</b> Punkte.</p>
      <div className="flex flex-wrap gap-2">
        {QUICK.map((q) => (
          <button key={q} onClick={() => setAmount(String(q))} data-testid={`sky-quick-${q}`} className={`h-9 px-4 rounded-full text-sm font-bold transition-colors ${Number(amount) === q ? "pink-gradient text-white" : "bg-rose-50 text-rose-600 hover:bg-rose-100"}`}>{q}</button>
        ))}
      </div>
      <div className="flex gap-2">
        <input inputMode="numeric" value={amount} onChange={(e) => setAmount(e.target.value.replace(/\D/g, ""))} data-testid="sky-amount" className="flex-1 min-w-0 h-11 rounded-xl border border-pink-100 px-4 font-bold outline-none focus:border-rose-300" />
        <button onClick={give} disabled={busy} data-testid="sky-donate-btn" className="h-11 px-5 rounded-full bg-indigo-950 text-amber-100 font-bold inline-flex items-center gap-2 disabled:opacity-60">{busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Sparkles className="w-4 h-4" />} Verschenken</button>
      </div>
    </div>
  );
}
